import { Translations } from './translations.model';

export const en: Translations = {
    app: {
        name: 'NS account management',
        logout: 'Logout',
    },
    unauthenticated: {
        title: 'You have been signed out',
        description: 'Your session has ended successfully. You can sign in again whenever you want to continue working.',
        primaryAction: 'Sign in again',
    },
    unauthorized: {
        title: 'You do not have access to this application',
        description: 'Your account is signed in, but you do not have access to this workspace. Contact your administrators.',
        primaryAction: 'Sign out and try another account',
        secondaryAction: 'Back to login',
    },
    search: {
        title: 'Users',
        searchBy: 'Search by',
        searchTerm: 'Search term',
        emailAddress: 'Email address',
        nsrNumber: 'NSR number',
        searchButton: 'Search',
        clearButton: 'Clear',
        placeholder: 'john.doe@example.com',
        searching: 'Searching...',
        accountDeletedMessage: 'Account was successfully deleted.',
        accountInvitedMessage: 'Invitation was successfully sent.',
        accountBlockedMessage: 'Account was successfully blocked.',
        accountUnblockedMessage: 'Account was successfully unblocked.',
        accountBlockedErrorMessage: 'Failed to block account. Please try again.',
        accountUnblockedErrorMessage: 'Failed to unblock account. Please try again.',
        emailVerificationRequestedMessage: 'Verification email was successfully requested.',
        businessActivationEmailResentMessage: 'Activation email was successfully resent.',
        personActionFailed: 'Something went wrong while performing this action. Please try again.',
        accountNotFoundTitle: 'Account not found',
        accountNotFoundMessage: 'No account matches the provided search value. Check the email or NSR number and try again.',
        invalidEmail: 'Please enter a valid email address.',
        emptySearchTermMessage: 'Please enter a search term.',
        genericSearchErrorMessage: 'Something went wrong while searching. Please try again.',
    },
    notFound: {
        notFoundMessage: 'The page you are trying to reach does not exist.',
        title: 'Page not found',
        backToHomeButton: 'Back to home page',
    },
    userDetails: {
        title: 'User details',
        backButton: 'Back to search',
        profileTitle: 'Profile',
        id: 'ID',
        emailAddress: 'Email address',
        verified: 'verified',
        emailVerification: {
            verified: 'Verified',
            notVerified: 'Not verified',
        },
        nsr: 'NSR',
        copyButton: 'Copy',
        copiedButton: 'Copied',
        editButton: 'Edit',
        saveButton: 'Save',
        cancelButton: 'Cancel',
        nsrCopiedMessage: 'NSR copied to clipboard.',
        nsrUpdatedMessage: 'NSR updated in Identity Provider.',
        nsrUpdateFailedMessage: 'Failed to update NSR. Please try again.',
        copyFailedMessage: 'Failed to copy NSR. Please copy it manually.',
        loadFailedMessage: 'Failed to load user details. Please try again.',
        changeButton: 'Change',
        accountTitle: 'Account',
        accountCreated: 'Account created',
        accountStatus: 'Account status',
        actionsButton: 'Actions',
        latestEvents: {
            title: 'Latest events',
            columns: {
                date: 'Date',
                event: 'Event',
                application: 'Application',
                username: 'Username',
                reason: 'Reason',
                browser: 'Browser',
            },
            nextPageAriaLabel: 'Go to next page',
        },
        dropdown: {
            deleteAccount: 'My NS - Delete account',
            verifyEmailAddress: 'My NS - Verify email address',
            requestNewVerificationEmail: 'My NS - Request new verification email',
            inviteConsumer: 'My NS - Invite consumer',
            blockAccount: 'My NS - Block account',
            unblockAccount: 'My NS - Unblock account',
            businessRequestActivationEmail: 'My NS Business - Resend activation link',
        },
        deleteWarning: {
            title: 'Safety instructions for deleting accounts',
            message: 'Deleting a user account is an irreversible administrative action. Please read the following instructions carefully before you proceed.',
            bullets: [
                'Deleting this account permanently removes the user’s access and all associated account data from NS Account Management.',
                'After deletion, this account can no longer be used to access NS services or internal applications, and it cannot be restored.',
                'Only delete accounts in accordance with NS policies and your local procedures for security, privacy, and compliance.',
                'If you are unsure whether this account may be deleted, stop now and consult your team lead or the NS support procedures.',
            ],
            acknowledgementLabel: 'I have read and understood the safety instructions for deleting this account.',
            confirmButton: 'Continue',
            cancelButton: 'Cancel'
        },
        deleteConfirm: {
            title: 'Delete account',
            message: 'Are you sure you want to delete account with email: {{email}}?',
            warning: 'This action cannot be undone.',
            confirmButton: 'Delete',
            cancelButton: 'Cancel',
        },
        organisationsTitle: 'Organisations',
        organisations: {
            name: 'Name',
            bpid: 'Debtor number',
            nsr: 'NSR',
        }
    }
};
